import React from 'react';

export const TeamPage: React.FC = () => {
  return (
    <div className="min-h-screen py-20">
      <div className="container mx-auto px-4">
        <h1 className="text-4xl font-bold text-white text-center mb-8">
          Our Team
        </h1>
        
        <div className="max-w-4xl mx-auto">
          <div className="bg-surface border border-border rounded-lg p-8 mb-8">
            <h2 className="text-2xl font-semibold text-white mb-4">
              Leadership Team
            </h2>
            <p className="text-text-secondary mb-6">
              Our experienced leadership team brings together expertise from blockchain, finance, and gold trading industries.
            </p>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-6">
              <div className="text-center">
                <div className="w-24 h-24 bg-gold/20 text-gold rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="fas fa-user text-2xl"></i>
                </div>
                <h3 className="text-xl font-semibold text-white mb-2">John Doe</h3>
                <p className="text-gold font-medium mb-2">CEO & Founder</p>
                <p className="text-text-secondary text-sm">
                  15+ years in blockchain and fintech industry
                </p>
              </div>
              
              <div className="text-center">
                <div className="w-24 h-24 bg-gold/20 text-gold rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="fas fa-user text-2xl"></i>
                </div>
                <h3 className="text-xl font-semibold text-white mb-2">Jane Smith</h3>
                <p className="text-gold font-medium mb-2">CTO & Co-Founder</p>
                <p className="text-text-secondary text-sm">
                  10+ years in software development and blockchain architecture
                </p>
              </div>
              
              <div className="text-center">
                <div className="w-24 h-24 bg-gold/20 text-gold rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="fas fa-user text-2xl"></i>
                </div>
                <h3 className="text-xl font-semibold text-white mb-2">Michael Johnson</h3>
                <p className="text-gold font-medium mb-2">CFO</p>
                <p className="text-text-secondary text-sm">
                  12+ years in finance and precious metals trading
                </p>
              </div>
              
              <div className="text-center">
                <div className="w-24 h-24 bg-gold/20 text-gold rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="fas fa-user text-2xl"></i>
                </div>
                <h3 className="text-xl font-semibold text-white mb-2">Sarah Wilson</h3>
                <p className="text-gold font-medium mb-2">COO</p>
                <p className="text-text-secondary text-sm">
                  8+ years in operations management and logistics
                </p>
              </div>
            </div>
          </div>
          
          <div className="bg-surface border border-border rounded-lg p-8 mb-8">
            <h2 className="text-2xl font-semibold text-white mb-4">
              Advisory Board
            </h2>
            <p className="text-text-secondary mb-6">
              Our advisory board consists of industry experts who provide strategic guidance and oversight.
            </p>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-6">
              <div className="text-center">
                <div className="w-20 h-20 bg-gold/20 text-gold rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="fas fa-user text-xl"></i>
                </div>
                <h3 className="text-lg font-semibold text-white mb-2">Dr. Robert Chen</h3>
                <p className="text-gold font-medium mb-1">Blockchain Advisor</p>
                <p className="text-text-secondary text-sm">
                  Blockchain researcher and academic
                </p>
              </div>
              
              <div className="text-center">
                <div className="w-20 h-20 bg-gold/20 text-gold rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="fas fa-user text-xl"></i>
                </div>
                <h3 className="text-lg font-semibold text-white mb-2">Maria Rodriguez</h3>
                <p className="text-gold font-medium mb-1">Gold Trading Advisor</p>
                <p className="text-text-secondary text-sm">
                  Former senior trader at major gold exchange
                </p>
              </div>
              
              <div className="text-center">
                <div className="w-20 h-20 bg-gold/20 text-gold rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="fas fa-user text-xl"></i>
                </div>
                <h3 className="text-lg font-semibold text-white mb-2">David Kim</h3>
                <p className="text-gold font-medium mb-1">Legal Advisor</p>
                <p className="text-text-secondary text-sm">
                  Expert in cryptocurrency and securities law
                </p>
              </div>
            </div>
          </div>
          
          <div className="bg-surface border border-border rounded-lg p-8">
            <h2 className="text-2xl font-semibold text-white mb-4">
              Join Our Team
            </h2>
            <p className="text-text-secondary mb-6">
              We're always looking for talented individuals to join our team. Check out our open positions.
            </p>
            
            <div className="text-center mt-6">
              <a
                href="mailto:careers@idngold.com"
                className="inline-block bg-gradient-to-r from-gold to-gold-light text-black font-medium py-2 px-6 rounded-lg hover:from-indonesia-red hover:to-gold transition-all duration-300"
              >
                View Open Positions
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};